export default "assets/tata-motors-logo.png"